import { Metadata } from 'next'
import type { OpenGraph } from 'next/dist/lib/metadata/types/opengraph-types'
import { publicResource } from '../../utils'

export interface MetaDataEntity {
  title: string
  description: string
  keywords: string[]
  path: string
}

export const OpenGraphImages: OpenGraph['images'] = [
  {
    url: publicResource('/og/1_1.png'),
    alt: 'Aviagames',
    width: 512,
    height: 512,
  },
  {
    url: publicResource('/og/3_4.png'),
    alt: 'Aviagames',
    width: 384,
    height: 512,
  },
  {
    url: publicResource('/og/4_3.png'),
    alt: 'Aviagames',
    width: 512,
    height: 384,
  },
  {
    url: publicResource('/og/4_5.png'),
    alt: 'Aviagames',
    width: 512,
    height: 640,
  },
  {
    url: publicResource('/og/9_16.png'),
    alt: 'Aviagames',
    width: 540,
    height: 960,
  },
  {
    url: publicResource('/og/16_9.png'),
    alt: 'Aviagames',
    width: 960,
    height: 540,
  },
]

export const generateMetadata = (data: MetaDataEntity): Metadata => {
  const { title, description, keywords, path } = data
  return {
    title,
    description,
    keywords,
    openGraph: {
      type: 'website',
      siteName: 'Aviagames',
      title: title!,
      description: description!,
      url: process.env.SITE_URL + path,
      images: OpenGraphImages,
    },
    twitter: {},
  }
}
